import Footer from '@/components/layout/footer';
import { NavbarPublic as Navbar } from '@/components/layout/navbar/navbar.public';
import { BookingCleaning } from '@/features/consumer/booking-cleaning';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const bookingSearchSchema = z.object({
  address_id: z.string().optional(),
  /** Completed booking id — hydrate browse flow at Availability (book again). */
  book_again: z.string().optional(),
  /** Preset hours from the homepage "One Price" section. */
  hours: z.string().optional(),
  /** Preset ZIP code from the hero section. */
  zip: z.string().optional(),
  /** Preset bedroom count from the homepage "One Price" section. */
  bedroom: z.string().optional(),
  /** Preset bathroom count from the homepage "One Price" section. */
  bathroom: z.string().optional(),
  /** Preset type of cleaning from the homepage "One Price" section. */
  type_of_cleaning: z.string().optional(),
  /** Flag from the homepage "One Price" section to enable the easy booking flow. */
  easy: z.string().optional(),
});

export const Route = createFileRoute('/(consumer)/(bookings)/booking')({
  component: LayoutBookingCleaning,
  validateSearch: bookingSearchSchema,
});

function LayoutBookingCleaning() {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <div className="mt-[80px] md:mt-[140px]">
        <BookingCleaning />
      </div>
      <Footer />
    </div>
  );
}
